export {fetch} from './src/fetch-service';



// WEBPACK FOOTER //
// ./~/@deere/cps-it.fetch-wrapper/index.js